<div id="cart-drawer" class="cart-drawer-container" cv-custom-scrollbar="{ autoHideScrollbar: autoHideScrollbar }"
    data-mcs-theme="dark-3">
    <!-- Header -->
    <div class="cart-drawer-header-container" [hidden]="pointStoreProducts?.length == 0 && !isCxOne">
        <p [ngClass]="{'cart-drawer-header-title lato-bold font-size-18': true, 'cxone-cart-drawer-header-title': isCxOne}" 
        class=" " cvLocalizedText langSection="MarketPlace" langKey="Added_in_Cart">Added in Cart</p>
    </div>
    <!-- Body -->
    <overlay-scrollbars class="cart-drawer-body-container">
        <!-- <div class="cart-drawer-border-added-item" [hidden]="!highlightCartItem"
            [ngClass]="lastAdded != undefined && !lastAdded.HasProductVariations ? 'drawer-border-noVariation' :''">
        </div> -->

        <div class="drawer-empty-state" *ngIf="!isCxOne" [hidden]="pointStoreProducts?.length > 0">
            <img class="cart-drawer-body-icon-empty-cart" src="../App_Themes/Standard/Images/AgentOrderHistory/cart.svg" />
            <span class="cart-drawer-body-text-empty-cart" cvLocalizedText langSection="MarketPlace"
                langKey="Empty_Cart">Your cart is empty</span>
        </div>
        <div class="drawer-empty-state" *ngIf="isCxOne" [hidden]="pointStoreProducts?.length > 0">
            <svg class="cxone-image-empty-cart-drawer">
                <use href="../App_Themes/CXone/icons/empty-state.svg#empty-state"></use>
            </svg>
           <span class="cxone-text-empty-cart-drawer" cvLocalizedText langSection="MarketPlace"
                langKey="Empty_Cart">Your cart is empty</span>
        </div>


        <div class="row cart-drawer-items-container" *ngFor="let cartItem of pointStoreProducts">
            <div class="cart-drawer-cointaner-product-img">
                <img class="cart-drawer-product-img"
                    [src]="getProductImage(cartItem)"
                    alt="Image not available" *ngIf="!isCxOne"/>

                <img class="cart-drawer-product-img cxone-cart-drawer-cdpi"
                    [src]="getProductImage(cartItem)"
                    *ngIf="isCxOne && 
                            (cartItem.ProductImageID != 0 && cartItem.ProductImageID != null ||
                            cartItem.VariationImgID != 0 && cartItem.VariationImgID != null)" />
                
                <div *ngIf="isCxOne && ((cartItem.ProductImageID == 0 || cartItem.ProductImageID == null) &&
                            (cartItem.VariationImgID == 0 || cartItem.VariationImgID == null))" 
                    class="cart-drawer-product-img-svg d-flex flex-column justify-content-center align-items-center">
                    <svg class="not-available">
                        <use href="../App_Themes/CXone/icons/not-available-image.svg#not-available-image"></use>
                    </svg>
                </div>    
            </div>
            <div class="d-flex flex-column cart-drawer-product-detail">
                <label class="text-truncate cart-drawer-product-detail-label" [attr.title]="cartItem.Title">
                    <span [ngClass]="{'lato-bold font-size-16 color-theUpsideDown': true, 'cxone-cdpd-title': isCxOne}">{{cartItem.Title}}</span>
                </label>
        
                <label class="text-truncate cart-drawer-product-detail-label" 
                        [attr.title]="cartItem.VariationName || ''" 
                        *ngIf="cartItem.VariationName != '' && cartItem.VariationName != undefined">
                    <span [ngClass]="{'cart-drawer-items-title-text': true, 'cxone-cdpd-title-text': isCxOne}" cvLocalizedText langSection="MarketPlace_Management"
                    langKey="{{getVariationName(cartItem?.ProductID)}}_Detail">{{getVariationName(cartItem?.ProductID)}}</span>
                    <span [ngClass]="{'lato-bold font-size-14 color-theUpsideDown': true, 'cxone-cdpd-title-description': isCxOne}">
                        {{cartItem.VariationName || ''}}
                    </span>
                </label>
        
                <label class="cart-drawer-product-detail-label">
                    <span [ngClass]="{'cart-drawer-items-title-text': true, 'cxone-cdpd-title-text': isCxOne}" cvLocalizedText langSection="MarketPlace_Management"
                            langKey="Quantity_Detail">Quantity:</span>
                    <span [ngClass]="{'lato-bold font-size-14 color-theUpsideDown': true, 'cxone-cdpd-title-description': isCxOne}">{{cartItem.Quantity}}</span>
                </label>
        
                <div class="d-flex flex-row">
                    <span [ngClass]="{'cart-drawer-items-title-text': true, 'cxone-cdpd-title-text': isCxOne}" cvLocalizedText langSection="MarketPlace_Management"
                            langKey="Total_Price_Detail">Total Price:</span>
                    <div class="cart-drawer-items-icon">
                        <svg *ngIf="isCxOne" class="drawer-coin-cxone-icon dcci-list fill-bananaSlug">
                            <use href="../App_Themes/CXone/icons/coins.svg#coins"></use>
                        </svg>
                        <svg *ngIf="!isCxOne" class="icon-16 fill-bananaSlug" style="margin-bottom: 4px;">
                            <use href="../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use>
                        </svg>
                    </div>
                    <label class="text-truncate" style="margin-left: 4px;">
                        <span [ngClass]="{'lato-bold font-size-14 color-theUpsideDown': true, 'cxone-cdpd-title-description': isCxOne}">{{cartItem.CalculatedRealPrice *
                            cartItem.Quantity | cvNumberLocalize}}</span>
                    </label>
                </div>
            </div>
            <div class="cart-drawer-product-delete-icon">
                <button type="button" class="icon-btn fill-whaleTail drawer-delete-btn"
                    (click)="deleteItemFromCart(cartItem)">
                    <svg class="icon-16 fill-hover-cerulean" *ngIf="isCxOne">
                        <use href="../App_Themes/CXone/icons/delete.svg#delete"></use>
                    </svg>
                    <svg class="icon-16" *ngIf="!isCxOne">
                        <use href="../App_Themes/clearview-default/icons/utility/delete.svg#delete"></use>
                    </svg>
                </button>
            </div>
        </div>
    </overlay-scrollbars>
    <!-- Footer -->
    <div class="row cart-drawer-footer-container" [hidden]="pointStoreProducts?.length == 0 && !isCxOne">
        <div class="col-8">
            <div class="cart-drawer-footer-subcontainer lt">
                <label [ngClass]="{'lato-bold font-size-14 color-theUpsideDown': true, 'cxone-total-span': isCxOne}"
                cvLocalizedText langSection="MarketPlace" langKey="Total_Detail">
                   Total:
                </label>&nbsp;
                <svg *ngIf="isCxOne" class="drawer-coin-cxone-icon dcci-footer fill-bananaSlug">
                    <use href="../App_Themes/CXone/icons/coins.svg#coins"></use>
                </svg>
                <svg *ngIf="!isCxOne" class="icon-16 fill-bananaSlug">
                    <use href="../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use>
                </svg>&nbsp;
                <label [ngClass]="{'lato-bold font-size-14 color-theUpsideDown cart-drawer-footer-total': true, 'cxone-cart-drawer-footer-total': isCxOne}">
                    {{calculateCartTotal() | cvNumberLocalize}}
                </label>
            </div>
        </div>
        <div class="col-4">
            <div class="cart-drawer-footer-subcontainer rt">
                <button [ngClass]="{'cart-drawer-footer-goTo-button lato-bold text-truncate': true, 'cxone-goTo-button': isCxOne}" 
                        type="button"
                        [disabled]="!(pointStoreProducts.length > 0)"
                        (click)="(pointStoreProducts.length > 0) ? goToCart(): null"><span [matTooltip]="localization.get('Go_To_Cart') ?? 'Go to Cart'" cvLocalizedText langSection="MarketPlace" langKey="Go_To_Cart">Go to Cart</span></button>
            </div>
        </div>
        <!-- <div class="col-12 cart-drawer-footer">
        </div> -->
    </div>
</div>